/**
 * CrewMemberCard
 * Single crew member tile — side profile by default, swaps to front profile on hover
 * (desktop). Other cards in the row grey out while one is hovered.
 */

export function CrewMemberCard({ member, isHovered, onHover, onLeave, onSelect }) {
  return (
    <button
      type="button"
      className={`crew-member-card${isHovered ? ' crew-member-card--hovered' : ''}`}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      onClick={onSelect}
    >
      <div className="crew-member-image-stack">
        <img src={member.imageSide} alt="" className="crew-member-image crew-member-image--side" />
        <img src={member.imageFront} alt="" className="crew-member-image crew-member-image--front" />
      </div>
      <div className="crew-member-label">
        <span className="crew-member-name">{member.name}</span>
        <span className="crew-member-role">{member.role}</span>
      </div>
    </button>
  )
}
